import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async savePeriodoEvento({ commit }, periodo) {
      try {
        return await api.post('/eventos/periodos', periodo)
      } catch (error) {
        throw error
      }
    },

    async getPeriodosEventos({ commit }) {
      try {
        const response = await api.get('/eventos/periodos')

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getPeriodoEvento({ commit }, periodoId) {
      try {
        const response = await api.get(`/eventos/periodos/${periodoId}`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updatePeriodoEvento({ commit }, periodo) {
      try {
        return await api.put(`/eventos/periodos/${periodo.id}`, periodo)
      } catch (error) {
        throw error
      }
    },

    async activePeriodoEvento({ commit }, periodoId) {
      try {
        return await api.put(`/eventos/periodos/${periodoId}/active`)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
